export default __webpack_public_path__ + "static/media/about.94e7edf8.png";